import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import { initWebVitals } from '@/lib/perf';

// Initialize web vitals monitoring
void initWebVitals();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element nicht gefunden');

createRoot(rootEl).render(
    <StrictMode>
        <App />
    </StrictMode>,
);
